export default {
    init: function () {
        this.init();
    }
}